import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { DropPlaceholder } from 'components/MultiColumnBuilder/components/BaseOption/styles';
import InputControl from 'components/Inputs/InputControl';
import { TextEllipsisWithTooltip } from 'components/Kizen/Table';
import { layers } from 'app/spacing';
import EditableText from 'components/Kizen/EditableText';
import { WRAPPER_HEGHT } from './constants';

export const StyledDropPlaceholder = styled(DropPlaceholder)`
  & > div > div {
    border: 1px dashed var(--color-border-medium-light);
    background: var(--color-background-default);
    padding-top: 14px;

    padding-bottom: 14px;
    ${({ over }) =>
      over
        ? css`
            border-style: solid;
          `
        : ''}
  }
  p {
    color: var(--color-font-placeholder);
  }
  p:hover {
    color: ${({ noHover }) =>
      noHover ? 'var(--color-font-placeholder)' : 'var(--color-font-primary)'};
  }
`;

export const Wrapper = styled.div`
  min-height: ${WRAPPER_HEGHT}px;
  display: flex;
  flex-direction: column;
`;

export const StyledInputControl = styled(InputControl)`
  z-index: ${layers.content(10)};
`;

export const StyledEditableText = styled(EditableText)`
  display: flex;
  flex-grow: 1;
  margin-right: 20px;
  width: 0;
`;

export const StyledTextEllipsisWithTooltip = styled(TextEllipsisWithTooltip)`
  flex-grow: 1;
  margin-right: 20px;
  width: 0;

  ${({ isDynamic }) =>
    isDynamic
      ? css`
          color: var(--color-button-primary-default);
        `
      : ''}
`;

export const StyledBaseOption = styled.div`
  .innerItem > div {
    ${({ disabled }) =>
      disabled &&
      css`
        background-color: var(--color-background-light);
      `}
  }
`;

export const LeftColumnWrapper = styled.div`
  padding-top: 14px;
  padding-right: 20px;
  margin-left: -1px; //design nudge
`;

export const FieldOptionMenu = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 50px;
  & > div:nth-of-type(1) {
    width: 100%;
  }
`;

export const AddRecordOption = styled.div`
  display: flex;
  align-items: space-between;
  justify-content: space-between;
  flex-direction: column;
`;

export const AddRecordLabel = styled.div`
  display: flex;
  padding-bottom: 10px;
`;

export const SwitchWrapper = styled.div`
  margin-top: 2px;
`;

// Add a min-height to avoid layout shift when toggling on/off
export const AddButtonWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  padding-top: 20px;
  min-height: 82px;
  gap: 20px;

  & > div:nth-of-type(2) {
    flex: 1;
  }
`;

export const ActionsSection = styled.div`
  margin-top: 20px;
`;

export const EntityActionRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding-top: 20px;

  & > div:nth-of-type(1) {
    flex: 1;
  }
  & > div:nth-of-type(2) {
    flex: 1;
  }
`;

export const DeleteIcon = styled.span`
  & i {
    padding-top: 45px;
  }
`;

export const EntityActionsWrapper = styled.div`
  padding-top: 10px;
  max-width: 700px;
`;
